import { InitCookie } from '@patsnap/init-cookie';

export class InitCookieService {
    getEntryChannel() {
        const currentPath = window.location.pathname;
        const RdDetailPageRegs = [
            /\/ai-search/,
            /\/ai-ls\/chat-agent-share\/.*$/,
            /\/ai-ls\/document-agent-share\/.*$/,
            /\/ai\/agent/,
            /^.*\/page\/[^/]+$/,
            /^.*\/ai\/agent-flow\/[^/]+$/,
            /\/ai-search\/.*$/
        ];
        if (RdDetailPageRegs.some(pathReg => pathReg.test(currentPath))) {
            return 'rd_detail_page'
        }
        if (currentPath.includes('/customize-list')) {
            return 'customize';
        }
        if (currentPath.includes('/agent-list')) {
            return 'agent_list';
        }
        return 'eureka_home'
    }

    async init() {
        const entry_channel = this.getEntryChannel();
        if (entry_channel) {
            const cookie = new InitCookie({
                entry_channel,
            });
            return await cookie.init();
        }
    }
}

export const initCookieService = new InitCookieService();
